import script from "./AdminPriceAndStockChecker.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPriceAndStockChecker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__